module.exports = __webpack_public_path__ + "static/media/TUSD-BUSD.a75ec77a.svg";